module.exports = __webpack_public_path__ + "static/img/bgi.a892fe00.jpg";